export default {
  'Teklif Formu': 'Form Penawaran',
  'Kayıtlı Teklifler': 'Penawaran Tersimpan',
  'Kullanıcı Adı': 'Nama Pengguna',
  'Şifre': 'Kata Sandi',
  'Giriş Yap': 'Masuk',
  'Çıkış Yap': 'Keluar',
  'KDV Oranı': 'Tarif PPN',
  'Teklif Durumu': 'Status Penawaran',
  'Kaydet': 'Simpan',
  'PDF Önizleme': 'Pratinjau PDF',
  'PDF\'ye Aktar': 'Ekspor ke PDF',
  'E-posta ile Gönder': 'Kirim via Email',
  'Alıcı': 'Penerima',
  'Tarih': 'Tanggal',
  'Genel Toplam': 'Total Keseluruhan',
  'Not': 'Catatan',
  'KDV': 'PPN',
  'Alt Toplam': 'Subtotal',
  'Açıklama': 'Deskripsi',
  'Ürün Adı': 'Nama Produk',
  'SUT Kodu': 'Kode SUT',
  'Birim Alış Fiyatı': 'Harga Satuan',
  'Sipariş Adedi': 'Jumlah Pesanan',
  'Promosyon Ürün': 'Produk Promosi',
  'Toplam Adet': 'Total Jumlah',
  'Sipariş Tutarı': 'Jumlah Pesanan',
  'Durum': 'Status',
  'Kabul Edildi': 'Diterima',
  'Reddedildi': 'Ditolak',
  'Gönderildi': 'Dikirim',
  'Taslak': 'Draft',
  'Yurtiçi': 'Domestik',
  'Yurtdışı': 'Internasional',
  'Sipariş Oluştur': 'Buat Pesanan',
  'Ürün Sıralaması': 'Pengurutan Produk',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Produk diurutkan berdasarkan popularitas dan tingkat kepentingan',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Produk kardiologi dan bedah vaskular ditampilkan sebagai prioritas',
  'Ürün adı, açıklama veya barkod ile ara...': 'Cari berdasarkan nama produk, deskripsi atau barcode...',
  'Tüm Kategoriler': 'Semua Kategori',
  'Kutu görünüm': 'Tampilan grid',
  'Liste görünüm': 'Tampilan daftar',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Tidak ditemukan produk yang sesuai dengan kriteria Anda',
  'Ürün Adı Yok': 'Tidak Ada Nama Produk',
  'Kategori Yok': 'Tidak Ada Kategori',
  'Açıklama yok': 'Tidak ada deskripsi',
  'Firma Bilgilerini Doldurun': 'Isi Informasi Perusahaan',
  'Sepete Ekle': 'Tambah ke Keranjang',
  'Firma Bilgileri': 'Informasi Perusahaan',
  'Ülke Seçimi': 'Pilihan Negara',
  'Türkiye': 'Turki',
  'Almanya': 'Jerman',
  'ABD': 'AS',
  'Firma Ünvanı': 'Nama Perusahaan',
  'Vergi Dairesi': 'Kantor Pajak',
  'Vergi Numarası': 'NPWP',
  'Adres': 'Alamat',
  'Şehir': 'Kota',
  'Yetkili': 'Penanggung Jawab',
  'Telefon': 'Telepon',
  'Email': 'Email',
  'Bilgileri İlet': 'Kirim Informasi',
  'Lütfen eksik alanları doldurun': 'Silakan isi kolom yang kosong',
  'Firma kaydedilemedi': 'Perusahaan tidak dapat disimpan',
  'Firma bilgileri başarıyla iletildi': 'Informasi perusahaan berhasil dikirim',
  'Firma Ünvanı:': 'Nama Perusahaan:',
  'Yetkili Kişi:': 'Penanggung Jawab:',
  'Sepetiniz': 'Keranjang Anda',
  'Sepetiniz boş': 'Keranjang Anda kosong',
  'adet': 'pcs',
  'Düzenle': 'Edit',
  'Kaldır': 'Hapus',
  'Siparişi Tamamla': 'Selesaikan Pesanan',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Silakan kirim informasi perusahaan Anda secara lengkap terlebih dahulu',
  'Sipariş başarıyla kaydedildi': 'Pesanan berhasil disimpan',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Pesan selamat datang dan link akses dikirim ke email Anda',
  'Link 3 gün geçerlidir': 'Link berlaku 3 hari',
  'Sipariş kaydedilemedi': 'Pesanan tidak dapat disimpan',
  'Firma Bilgileri Gerekli': 'Informasi Perusahaan Diperlukan',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Isi informasi perusahaan terlebih dahulu untuk menambah ke keranjang',
  'Önce Bilgileri Doldurun': 'Isi Informasi Terlebih Dahulu',
  'Uyarı': 'Peringatan',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Anda harus mengisi informasi perusahaan terlebih dahulu untuk menambah ke keranjang',
  'SUT Kütüphanesi Tanımı': 'Definisi Perpustakaan SUT',
  'SUT Kodu:': 'Kode SUT:',
  'Standart': 'Standar',
  'Açıklama (isteğe bağlı)': 'Deskripsi (opsional)',
  'Partner Ol': 'Jadi Partner',
  'Partner başvuru popup açılacak': 'Popup aplikasi partner akan terbuka',
  'Dil': 'Bahasa',
  'E-posta': 'Email',
  'globalPartnersTitle': 'Kolaborasi dengan 30.000 Partner di Seluruh Dunia',
  'globalPartnersDesc': 'Jaringan global kami yang terdiri dari 30.000 partner mendorong inovasi bersama, berbagi pengetahuan dan kesuksesan timbal balik. Bersama-sama, kami terus memperluas batas perawatan pasien.',
  'bayiBasvuru': 'Formulir Aplikasi Partner INVAMED',
  'bayiBasvuruDesc': 'Isi formulir di bawah untuk bergabung dengan jaringan partner INVAMED. Setelah aplikasi Anda ditinjau, kami akan menghubungi Anda.',
  'applyFields': {
    'firma': 'Nama Perusahaan',
    'vergiNo': 'Kantor Pajak / NPWP',
    'yetkili': 'Nama Lengkap Penanggung Jawab',
    'telefon': 'Telepon',
    'email': 'Email',
    'adres': 'Alamat',
    'sektor': 'Bidang Usaha / Sektor',
    'sicil': 'Nomor SIUP',
    'web': 'Situs Web'
  },
  'Şifremi Unuttum': 'Lupa Kata Sandi',
  'Demo Giriş': 'Login Demo',
  'Bayi Başvurusu': 'Aplikasi Partner',
  'Yardım': 'Bantuan',
  'Giriş yapılıyor...': 'Sedang masuk...',
  'E-posta veya şifre hatalı': 'Email atau kata sandi salah',
  'Şifre sıfırlama e-postası gönderildi': 'Email reset kata sandi dikirim',
  'E-posta gönderilemedi': 'Email tidak dapat dikirim',
  'Vergi Dairesi / Vergi No': 'Kantor Pajak / NPWP',
  'Yetkili Adı Soyadı': 'Nama Lengkap Penanggung Jawab',
  'Faaliyet Alanı / Sektör': 'Bidang Usaha / Sektor',
  'Ticaret Sicil No': 'Nomor SIUP',
  'Web Sitesi': 'Situs Web',
  'Temel Bilgiler': 'Informasi Dasar',
  'Ek Bilgiler': 'Informasi Tambahan',
  'Başvuru Gönder': 'Kirim Aplikasi',
  'Başvuru gönderiliyor...': 'Mengirim aplikasi...',
  'Başvuru başarıyla gönderildi': 'Aplikasi berhasil dikirim',
  'Başvuru gönderilemedi': 'Aplikasi tidak dapat dikirim',
  'Sözleşme şartlarını kabul ediyorum': 'Saya menerima syarat-syarat perjanjian',
  'Dosya Yükle': 'Unggah File',
  'Dosya seçilmedi': 'File tidak dipilih',
  'Dosya yüklendi': 'File berhasil diunggah',
  'Dosya yüklenemedi': 'File tidak dapat diunggah',
  'Tamamla': 'Selesai',
  'Geri': 'Kembali',
  'İleri': 'Selanjutnya',
  'Kapat': 'Tutup',
  'Yardım İçeriği': 'Konten Bantuan',
  'dil': 'Bahasa',
  'Üye Ol': 'Daftar',
  'Üye Değil Misiniz?': 'Belum Terdaftar?',
  'Şimdi Üye Ol': 'Daftar Sekarang',
  'Misafir Kullanıcı': 'Pengguna Tamu',
  'Hızlı Sipariş': 'Pesanan Cepat',
  'Misafir Olarak Sipariş Verin': 'Buat Pesanan sebagai Tamu',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Pilih produk Anda dengan cepat dan buat pesanan tanpa login',
  'Giriş yapmadan sipariş oluşturun': 'Buat pesanan tanpa login',
  'Anında Erişim': 'Akses Instan',
  'Tüm ürünlere anında erişim': 'Akses instan ke semua produk',
  'Güvenli İşlem': 'Transaksi Aman',
  'SSL korumalı güvenli sipariş': 'Pesanan aman dengan perlindungan SSL',
  'Misafir Olarak Sipariş Oluştur': 'Buat Pesanan sebagai Tamu',
  'İpucu:': 'Tips:',
  'Daha fazla özellik için üye olun': 'Daftar untuk fitur lebih banyak',
  'Ücretsiz': 'Gratis',
  'Hızlı': 'Cepat',
  'Güvenli': 'Aman',
  'bayilikSozlesme': 'Saya telah membaca dan menerima syarat-syarat dan perjanjian kemitraan.',
  'geri': 'Kembali',
  'basvuruGonder': 'Kirim Aplikasi',
  'ileri': 'Selanjutnya',
  'sozlesmeGonderildi': 'Perjanjian Dikirim ke Email Anda!',
  'sozlesmeDesc': 'Silakan unggah Perjanjian Kemitraan INVAMED dan dokumen yang diperlukan yang dikirim ke email Anda.',
  'tamamla': 'Selesaikan Aplikasi',
  'basvuruAlindi': 'Aplikasi Anda Diterima!',
  'basvuruAlindiDesc': 'Tim INVAMED akan meninjau aplikasi Anda dan menghubungi Anda segera.',
  'Başvuru Durumu': 'Status Aplikasi',
  'Başvurunuz onay sürecindedir': 'Aplikasi Anda sedang ditinjau',
  'sifreSifirla': 'Reset Kata Sandi',
  'sifreSifirlaDesc': 'Masukkan email terdaftar Anda, kami akan kirim instruksi reset kata sandi.',
  'gonder': 'Kirim',
  'talimatGonderildi': 'Instruksi Dikirim',
  'sentDesc': 'Instruksi reset kata sandi dikirim ke <b>{email}</b>. Silakan cek email Anda.',
  'helpTitle': 'Bagaimana Saya Bisa Login?',
  'helpList': [
    'Untuk login ke panel partner INVAMED, masukkan email terdaftar dan kata sandi Anda.',
    'Untuk login dengan pengguna demo:',
    'Jika Anda lupa kata sandi, Anda dapat meminta reset melalui link "Lupa Kata Sandi".',
    'Jika mengalami masalah login, pastikan Anda memasukkan email dan kata sandi dengan benar. Jika masalah masih berlanjut, hubungi tim dukungan kami.'
  ],
  'partnerlikSozlesmeTitle': 'Perjanjian dan Syarat Kemitraan INVAMED',
  'partnerlikSozlesmeText': `1. KETENTUAN UMUM

Perjanjian ini dibuat antara INVAMED (selanjutnya disebut "Perusahaan") dengan calon partner (selanjutnya disebut "Partner") untuk melakukan kerjasama dalam penjualan peralatan dan perlengkapan medis.

2. SYARAT KEMITRAAN

2.1. Partner harus memiliki otoritas hukum untuk penjualan peralatan medis.
2.2. Partner harus menjadi organisasi yang beroperasi di sektor kesehatan.
2.3. Partner harus memiliki lisensi dan sertifikat yang diperlukan.
2.4. Partner harus dapat dipercaya secara finansial.

3. KEWAJIBAN PARA PIHAK

Kewajiban Perusahaan:
3.1. Menyediakan produk dan layanan berkualitas
3.2. Memberikan dukungan teknis
3.3. Melakukan pelatihan dan informasi
3.4. Transparan dalam penetapan harga

Kewajiban Partner:
3.1. Menyimpan produk dalam kondisi yang sesuai
3.2. Memberikan layanan pelanggan berkualitas
3.3. Mematuhi peraturan hukum
3.4. Melindungi merek Perusahaan

4. PENETAPAN HARGA DAN PEMBAYARAN

4.1. Harga ditentukan oleh Perusahaan
4.2. Partner wajib mempertahankan harga yang ditentukan
4.3. Ketentuan pembayaran ditentukan secara terpisah
4.4. Tingkat komisi dapat bervariasi berdasarkan kinerja

5. KERAHASIAAN DAN KEAMANAN

5.1. Para pihak wajib melindungi informasi rahasia satu sama lain
5.2. Informasi pelanggan harus dijaga kerahasiaannya
5.3. Harus mematuhi standar keamanan data

6. DURASI DAN PEMUTUSAN PERJANJIAN

6.1. Perjanjian ini berlaku selama 1 tahun
6.2. Dapat diperpanjang berdasarkan kesepakatan bersama
6.3. Dapat diputuskan dengan pemberitahuan 30 hari sebelumnya
6.4. Dapat diputuskan segera dalam kasus pelanggaran serius

7. PENYELESAIAN SENGKETA

7.1. Sengketa diselesaikan terlebih dahulu melalui negosiasi
7.2. Dalam hal tidak dapat diselesaikan, pengadilan Republik Turki berwenang

8. BERLAKUNYA

Perjanjian ini telah dibaca, dipahami dan diterima oleh para pihak. Saya menyatakan bahwa saya menerima semua pasal perjanjian ini dan akan memenuhi kewajiban saya.`,
  'partnerlikSozlesmeOnay': 'Saya telah membaca, memahami dan menerima Perjanjian dan Syarat Kemitraan INVAMED di atas. Saya menyatakan bahwa saya menerima semua pasal perjanjian ini dan akan memenuhi kewajiban saya.',
  'sozlesmeyiGoruntule': 'Lihat Perjanjian',
  'sozlesmeyiKapat': 'Tutup',
  'Ürün': 'Produk',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Pilih dari daftar produk untuk menambah produk',
  'Etiketler': 'Label',
  'Öncelikli': 'Prioritas',
  'Ülke Seçiniz': 'Pilih Negara',
  'Firma / Sağlık Profesyoneli': 'Perusahaan / Profesional Kesehatan',
  'Şehir Seçiniz': 'Pilih Kota',
  'Yetkili Kişi': 'Penanggung Jawab',
  'UDI Kodu': 'Kode UDI',
  'Teklif başarıyla kaydedildi!': 'Penawaran berhasil disimpan!',
  'Aynı teklif zaten kayıtlı!': 'Penawaran yang sama sudah tersimpan!',
  'Kullanıcı adı veya şifre hatalı!': 'Nama pengguna atau kata sandi salah!',
  'Teklif No': 'Nomor Penawaran',
  'Teklifler': 'Penawaran',
  'Yedeklenecek teklif yok!': 'Tidak ada penawaran untuk dicadangkan!',
  'Yedek dosyası indirildi.': 'File cadangan diunduh.',
  'Yedek başarıyla yüklendi.': 'Cadangan berhasil dimuat.',
  'Geçersiz veya bozuk dosya!': 'File tidak valid atau rusak!',
  'Yedekle (JSON)': 'Cadangkan (JSON)',
  'Geri Yükle': 'Muat Ulang',
  'Kayıtlı teklif yok.': 'Tidak ada penawaran tersimpan.',
  'E-posta Durumu': 'Status Email',
  'İşlemler': 'Transaksi',
  'E-posta ile gönderildi': 'Dikirim via email',
  'E-posta gönderilmedi': 'Email tidak dikirim',
  'Görüntüle': 'Lihat',
  'Sil': 'Hapus',
  'Gönderildi': 'Dikirim',
  'Gönderilmedi': 'Tidak Dikirim',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'ID Penawaran tidak ditemukan! Silakan coba lagi.',
  'Lütfen partner seçiniz.': 'Silakan pilih partner.',
  'Lütfen teslimat tarihi belirtiniz.': 'Silakan tentukan tanggal pengiriman.',
  'Proforma başarıyla oluşturuldu!': 'Proforma berhasil dibuat!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Proforma dibuat tetapi produk tidak dapat ditambahkan. Periksa konsol untuk detail.',
  'Link başarıyla silindi': 'Link berhasil dihapus',
  'Link kopyalandı!': 'Link disalin!',
  'Ödeme durumu başarıyla güncellendi!': 'Status pembayaran berhasil diperbarui!',
  'dosyası okunamadı!': 'file tidak dapat dibaca!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'Anda harus memilih kolom kode SUT dan harga untuk semua file!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'Tidak ditemukan baris valid untuk dimuat! Pastikan ada baris dengan kode SUT dan harga yang terisi di file.',
  'Yükleme sırasında hata oluştu!': 'Terjadi kesalahan saat memuat!',
  'Otomatik etiket ekleme başarısız!': 'Penambahan label otomatis gagal!',
  'Etiketler başarıyla güncellendi!': 'Label berhasil diperbarui!',
  'Etiketler güncellenirken hata oluştu!': 'Terjadi kesalahan saat memperbarui label!',
  'Resim başarıyla yüklendi!': 'Gambar berhasil diunggah!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Gambar diunggah tetapi produk tidak dapat diperbarui!',
  'Resim yüklenirken hata oluştu!': 'Terjadi kesalahan saat mengunggah gambar!',
  'Ürün başarıyla güncellendi!': 'Produk berhasil diperbarui!',
  'Ürün güncellenirken hata oluştu!': 'Terjadi kesalahan saat memperbarui produk!',
  'Hata:': 'Kesalahan:',
  'Güncelleme hatası:': 'Kesalahan pembaruan:',
  'Alanlar yüklendi:': 'Kolom dimuat:',
  'alan': 'kolom',
  'Connect Free!': 'Hubungkan gratis!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Temukan produk kami yang paling populer',
  'Tüm Kategoriler': 'Semua Kategori',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 produk ditampilkan (Total: 8000+)',
  'Tüm Ürünleri Gör →': 'Lihat Semua Produk →',
  'Detaylar': 'Detail',
  'Sipariş Ver': 'Pesan Sekarang',
  'Giriş Yap': 'Masuk',
  'Hesabınıza giriş yapın': 'Masuk ke akun Anda',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Situs ini dilindungi oleh reCAPTCHA dan Kebijakan Privasi Google serta Ketentuan Layanan berlaku.',
  'Ürün Kataloğumuz': 'Katalog Produk Kami',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Kami menyediakan lebih dari 8000 produk',
  '1,3B': '1,3K',
  'Partner': 'Mitra',
  '8,4M': '8,4Jt',
  'Toplam Üretim': 'Total Produksi',
  '23': '23',
  'Branş': 'Cabang',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Total Pesanan',
  'Connect Now': 'Hubungkan Sekarang',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Daftar gratis untuk mengakses semua informasi di satu tempat.',
  'Ürün Detayları': 'Detail Produk',
  'Kapat': 'Tutup',
  'Yükleniyor...': 'Memuat...',
  'Hata': 'Kesalahan',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} produk ditampilkan (Total: 8000+)',
  'Şehir Seçimi': 'Pemilihan Kota',
  'Firma / Sağlık Profesyoneli': 'Perusahaan / Profesional Kesehatan',
  'Yetkili Kişi': 'Orang yang Berwenang',
  'Telefon': 'Telepon',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Informasi Dasar',
  'Ek Bilgiler': 'Informasi Tambahan',
  'Faaliyet Alanı / Sektör': 'Area Aktivitas / Sektor',
  'Ülke Seçimi': 'Pemilihan Negara',
  'Ülke adı veya kodu ara...': 'Cari nama atau kode negara...',
  'region.Avrupa': 'Eropa',
  'region.Amerika': 'Amerika',
  'region.Asya': 'Asia',
  'region.Afrika': 'Afrika',
  'region.Okyanusya': 'Oseania',
  'region.Diğer': 'Lainnya',
  'country.TR': 'Turki',
  'country.US': 'Amerika Serikat',
  'country.DE': 'Jerman',
  'country.FR': 'Prancis',
  'country.GB': 'Britania Raya',
  'country.IT': 'Italia',
  'country.ES': 'Spanyol',
  'country.RU': 'Rusia',
  'country.CN': 'Tiongkok',
  'country.JP': 'Jepang',
  'country.KR': 'Korea Selatan',
  'country.IN': 'India',
  'country.BR': 'Brasil',
  'country.CA': 'Kanada',
  'country.AU': 'Australia',
  'Ticaret Sicil No': 'Nomor Registrasi Dagang',
};
